import {Component, Input, Output, EventEmitter, ViewChild, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-characterSet-select',
  templateUrl: './characterSet-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: CharacterSetSelectComponent
    }
  ]
})
export class CharacterSetSelectComponent implements OnInit, ControlValueAccessor {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Input()
  apiHost = 'smsd';

  @Output()
  characterSetChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  characterSet:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  nullable:boolean = false;

  @Input()
  nullLabel:string = 'Undefined'

  options:any[];

  onChange = (mpsScope) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.onChange(e);
    this.characterSetChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(characterSet: string): void {
    this.characterSet = characterSet;
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  reload() {
    let params:HttpParams = new HttpParams();
    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/${this.apiHost}/characterSets`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        if (this.nullable) {
          this.options.unshift({name: this.nullLabel, id: "NULL"});
        }
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.reload();
  }
}
